import moment from 'moment';
import { closeAssociatesDetails } from 'redux/reducers/closeAssociatesDetails';
import premisesDetails from 'redux/reducers/premisesDetails';

const toCamelCase = (str) => {
  let trimmedString = str.replace(/^\s+/g, '');
  return trimmedString.charAt(0).toUpperCase() + trimmedString.slice(1).toLowerCase();
};

const formatAddress = (address) => {
  if (address && address.enterManually) {
    return `${address.addressLine} ${address.suburb} ${address.state.label} ${address.postcode}`;
  } else if (address && address.lookupValue && address.lookupValue.label) {
    return address.lookupValue.label;
  } else {
    return '';
  }
};

//Logic to get Addresses
const getAddress = (address, addressType, sameAsResidentialFlag) => {
  if (address && address.addressNotChanged === false) {
    if (address && address.enterManually && !address.international) {
      return `${address.addressLine}, ${address.suburb}, ${address.state.label}, ${address.postcode}`;
    } else if (address && address.lookupValue && address.lookupValue.label) {
      return address.lookupValue.label;
    } else {
      return `${address.addressLine}, ${address.suburb}, ${address.state ? address.state + ',' : ''} ${
        address.postcode
      }, ${address.country}`;
    }
  } else if (sameAsResidentialFlag && addressType === 'Postal') {
    return `${address.addressLine}, ${address.suburb}, ${address.state ? address.state + ',' : ''} ${
      address.postcode
    }, ${address.country}`;
  } else {
    return `${address.addressLine}, ${address.suburb}, ${address.state ? address.state + ',' : ''} ${
      address.postcode
    }, ${address.country}`;
  }
};

const getFormatAddressFromAddressLine = (addressLine, addressType) => {
  let addrParts = addressLine.split(',');

  return {
    addressNotChange: true,
    addressType: addressType,
    details: {
      status: 'Success',
      Address: {
        addressLine1: addrParts[0]?.trim(),
        suburb: addrParts[1]?.trim(),
        state: addrParts[2]?.trim(),
        postcode: addrParts[3]?.trim(),
        country: 'Australia'
      }
    }
  };
};

const format2FAAddress = (addresses, type) => {
  const a = addresses.find((a) => a.addressType === type);
  if (a !== undefined) {
    return `${
      a.addressLine
        ? a.addressLine + ', '
        : `${a.unitNo ? a.unitNo + ' ' : ''}${a.propertyName ? a.propertyName + ' ' : ''}${
            a.streetNoStart ? a.streetNoStart + ' ' : ''
          }${a.streetName ? a.streetName + ' ' : ''}${a.streetType ? a.streetType + ', ' : ''}`
    }${a.suburb ? a.suburb + ', ' : ''}${a.state}, ${a.postCode}`;
  } else {
    return '';
  }
};

const onlyNumbers = (input) => input.replace(/\D/g, '');

const onlyCharacters = (input) => input.replace(/[^a-zA-Z\  ]/g, '');

const onlyPhoneCharacters = (input) => input.replace(/[^\(\)\+0-9]+/g, '');

const setDigitsAndFocusNext = (event, numDigits, setter, next) => {
  const value = onlyNumbers(event.target.value);
  if (setter) {
    setter(value);
    if (value.length >= numDigits && next) {
      next.current.focus();
    }
  }
};

const formatMoney = (number, decPlaces, decSep, thouSep, symbol) => {
  const decPlaces2 = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
  const decSep2 = typeof decSep === 'undefined' ? '.' : decSep;
  thouSep = typeof thouSep === 'undefined' ? ',' : thouSep;
  var sign = number < 0 ? '-' : '';
  var i = String(parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces2))));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    (symbol || '') +
    sign +
    (j ? i.substr(0, j) + thouSep : '') +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
    (decPlaces2
      ? decSep2 +
        Math.abs(number - i)
          .toFixed(decPlaces2)
          .slice(2)
      : '')
  );
};

const objOfJsonArrayItem = (arrObjects, key, value) => {
  let obj = {};
  arrObjects.map((el, i) => {
    if (el[key] && value && el[key].toLowerCase() == value.toLowerCase()) {
      obj = el;
    }
  });
  console.log(value, obj);
  return obj;
};

const getFinalAdddress = (adddressValue) => {
  let finalAdddress;
  if (adddressValue.lookupValue || adddressValue.enterManually == true) {
    finalAdddress = {
      addressNotChanged: false,
      ...adddressValue
    };
  } else {
    finalAdddress = {
      addressNotChanged: true,
      addressType: 'Postal'
    };
  }
  return finalAdddress;
};

const getFinalDuplicateAdddress = (adddressValue, type) => {
  let finalAdddress;
  if (adddressValue.lookupValue || adddressValue.enterManually == true) {
    finalAdddress = {
      ...adddressValue,
      addressNotChanged: false
    };
  } else {
    finalAdddress = {
      addressNotChanged: true,
      addressType: type
    };
  }
  return finalAdddress;
};

const getManualAddress = (address) => {
  if (address) {
    return {
      addressLine: address.addressLine,
      suburb: address.suburb,
      state: address.state.value,
      postCode: address.postcode
    };
  }
  return null;
};

const getApplicantAddressDetail = (primaryAddress, secondaryAddress, individualAddresses) => {
  let address = [];
  if (primaryAddress) {
    if (primaryAddress) {
      address = address.concat({
        addressType: 'Residential',
        enterManually: primaryAddress?.enterManually,
        manualAddress: !primaryAddress.lookupValue ? getManualAddress(primaryAddress) : {},
        lookupValue: primaryAddress.lookupValue ? primaryAddress.lookupValue : {},
        details: primaryAddress.details ? primaryAddress.details : {},
        addressNotChanged: primaryAddress.addressNotChanged
      });
    }
  } else {
    if (individualAddresses) {
      const indResidentialAddress = individualAddresses.find((a) => a.addressType === 'Residential');

      address = address.concat({
        addressNotChanged: false,
        addressType: 'Residential',
        details: {
          Status: 'Success',
          Address: {
            addressLine1: indResidentialAddress.addressLine1,
            suburb: indResidentialAddress.suburb,
            state: indResidentialAddress.state,
            postcode: indResidentialAddress.postcode,
            country: indResidentialAddress.country,
            streetName: indResidentialAddress.streetName
          }
        }
      });
    }
  }

  if (secondaryAddress) {
    if (secondaryAddress && !secondaryAddress.international) {
      address = address.concat({
        addressType: 'Postal',
        enterManually: secondaryAddress.enterManually,
        manualAddress: !secondaryAddress.lookupValue ? getManualAddress(secondaryAddress) : {},
        lookupValue: secondaryAddress.lookupValue ? secondaryAddress.lookupValue : {},
        details: secondaryAddress.details ? secondaryAddress.details : {}
      });
    }
  } else {
    if (individualAddresses) {
      const indPostalAddress = individualAddresses.find((a) => a.addressType === 'Postal');

      address = address.concat({
        addressNotChanged: false,
        addressType: 'Postal',
        details: {
          Status: 'Success',
          Address: {
            addressLine1: indPostalAddress.addressLine1,
            suburb: indPostalAddress.suburb,
            state: indPostalAddress.state,
            postcode: indPostalAddress.postcode,
            country: indPostalAddress.country
          }
        }
      });
    }
  }

  return address;
};

const getAddressDetail = (primaryAddress, secondaryAddress, sameAsResidentialFlag, addresses, partyType) => {
  let address = [];
  if (primaryAddress && primaryAddress.addressNotChanged === false) {
    if (primaryAddress && !primaryAddress.international) {
      address = address.concat({
        addressType: partyType === 'Individual' ? 'Residential' : 'Business',
        enterManually: primaryAddress.enterManually,
        manualAddress: !primaryAddress.lookupValue ? getManualAddress(primaryAddress) : {},
        lookupValue: primaryAddress.lookupValue ? primaryAddress.lookupValue : {},
        details: primaryAddress.details ? primaryAddress.details : {},
        addressNotChanged: primaryAddress.addressNotChanged
      });
    } else if (primaryAddress && primaryAddress.international) {
      address = address.concat({
        addressNotChanged: primaryAddress.addressNotChanged,
        addressType: partyType === 'Individual' ? 'Residential' : 'Business',
        details: {
          Status: 'Success',
          Address: {
            addressLine1: primaryAddress.addressLine,
            suburb: primaryAddress.suburb,
            state: primaryAddress.state,
            postcode: primaryAddress.postcode,
            country: primaryAddress.country
          }
        }
      });
    }
  } else if (primaryAddress) {
    address = address.concat({
      addressType: partyType === 'Individual' ? 'Residential' : 'Business',
      addressNotChanged: primaryAddress.addressNotChanged
    });
  }

  if (!secondaryAddress) {
    return address;
  }

  if (secondaryAddress.addressNotChanged === false) {
    if (secondaryAddress && !secondaryAddress.international) {
      address = address.concat({
        addressType: 'Postal',
        enterManually: secondaryAddress.enterManually,
        manualAddress: !secondaryAddress.lookupValue ? getManualAddress(secondaryAddress) : {},
        lookupValue: secondaryAddress.lookupValue ? secondaryAddress.lookupValue : {},
        details: secondaryAddress.details ? secondaryAddress.details : {}
      });
    } else if (secondaryAddress && secondaryAddress.international) {
      address = address.concat({
        addressNotChanged: secondaryAddress.addressNotChanged,
        addressType: 'Postal',
        details: {
          Status: 'Success',
          Address: {
            addressLine1: secondaryAddress.addressLine,
            suburb: secondaryAddress.suburb,
            state: secondaryAddress.state,
            postcode: secondaryAddress.postcode,
            country: secondaryAddress.country
          }
        }
      });
    }
  } else if (sameAsResidentialFlag) {
    if (secondaryAddress && !secondaryAddress.international) {
      const a = addresses.find((a) => a.addressType === 'Residential');
      address = address.concat({
        addressNotChanged: false,
        addressType: 'Postal',
        details: {
          Status: 'Success',
          Address: {
            addressLine1: a.addressLine,
            suburb: a.suburb,
            state: a.state,
            postcode: a.postcode,
            country: a.country
          }
        }
      });
    }
  } else {
    address = address.concat({
      addressType: 'Postal',
      addressNotChanged: secondaryAddress.addressNotChanged
    });
  }

  return address;
};

const getMultipleAddress = (address, primaryAddress, addressType) => {
  if (primaryAddress && primaryAddress.addressNotChanged === false) {
    if (primaryAddress && !primaryAddress.international) {
      address = address.concat({
        addressType: addressType,
        enterManually: primaryAddress.enterManually,
        manualAddress: !primaryAddress.lookupValue ? getManualAddress(primaryAddress) : {},
        lookupValue: primaryAddress.lookupValue ? primaryAddress.lookupValue : {},
        details: primaryAddress.details ? primaryAddress.details : {},
        addressNotChanged: primaryAddress.addressNotChanged
      });
    } else if (primaryAddress && primaryAddress.international) {
      address = address.concat({
        addressNotChanged: primaryAddress.addressNotChanged,
        addressType: addressType,
        details: {
          Status: 'Success',
          Address: {
            addressLine1: primaryAddress.addressLine,
            suburb: primaryAddress.suburb,
            state: primaryAddress.state,
            postcode: primaryAddress.postcode,
            country: primaryAddress.country
          }
        }
      });
    }
  } else if (primaryAddress) {
    address = address.concat({
      addressType: addressType,
      addressNotChanged: primaryAddress.addressNotChanged
    });
  }

  return address;
};

const getMultipleAddressDetail = (primaryAddress, otherAddresses, sameAsRegisteredBusiness) => {
  let address = [];
  address = getMultipleAddress(address, primaryAddress, 'Registered Office');

  if (sameAsRegisteredBusiness[0]) {
    address = getMultipleAddress(address, primaryAddress, 'Business');
  } else {
    if (otherAddresses.length > 0) {
      address = getMultipleAddress(address, otherAddresses[0], 'Business');
    }
  }

  if (sameAsRegisteredBusiness[1]) {
    address = getMultipleAddress(address, primaryAddress, 'Postal');
  } else {
    if (otherAddresses.length > 1) {
      address = getMultipleAddress(address, otherAddresses[1], 'Postal');
    }
  }

  return address;
};

const formattedJsonTOSubmit = (
  application,
  applicantDetails,
  collectionOfLicence,
  disclosures,
  documents,
  employment,
  tattooistDetails,
  twoFA
) => {
  const data = {};

  let tempEmploymentHistory = employment.employmentHistory.map((el) => {
    console.log(el);

    let dateCommenced = moment(el.monthOfCommenced + '/' + el.dayOfCommenced + '/' + el.yearOfCommenced).format(
      'DD/MM/YYYY'
    );
    let dateFinished =
      el.currentEmployment == 1
        ? null
        : moment(el.monthOfFinished + '/' + el.dayOfFinished + '/' + el.yearOfFinished).format('DD/MM/YYYY');

    return {
      name: el.name,
      phoneNo: el.phoneNumber,
      position: el.position,
      startDate: dateCommenced,
      endDate: dateFinished,
      currentEmployment: el.currentEmployment == 1 ? true : false
    };
  });
  let formattedJSON = {
    applicationId: application.applicationId,
    licenceType: 'Tattooist Licence',
    applicationNo: application.applicationNo,
    applicantType: 'individual',
    durationRequested: tattooistDetails.duration,
    collectionServiceCentre: collectionOfLicence.centreLocation.value,
    individualApplicantDetails: {
      roles: ['Applicant'],
      id: 'applicant1',
      firstName: twoFA.data ? twoFA.data.firstName : '',
      middleName: '',
      surname: twoFA.data ? twoFA.data.lastName : '',
      dateofbirth: twoFA.data
        ? moment(twoFA.data.month + '/' + twoFA.data.day + '/' + twoFA.data.year).format('DD/MM/YYYY')
        : null,
      placeOfBirth: applicantDetails.placeOfBirth,
      twoFaVerified: twoFA.data ? true : false,
      hasOtherNames: applicantDetails.hasOtherNames == 'yes' ? true : false,
      otherNames: applicantDetails.otherNames,
      identificationDetails: applicantDetails.identificationDetails,
      contactPart: applicantDetails.contactPart,
      addresses: [
        {
          addressType: 'Residential',
          enterManually: true,
          manualAddress: applicantDetails.addressResidential.manualAddress,
          lookupValue: {},
          details: {}
        },
        {
          addressType: 'Postal',
          enterManually: true,
          manualAddress: applicantDetails.addressPostal.manualAddress,
          lookupValue: {},
          details: {}
        }
      ],
      employmentHistory: tempEmploymentHistory
    },
    questionList: [
      {
        questionGroupDescription: 'Disclosures',
        questionAnswers: [
          {
            question:
              'Have you had any application for any licence, certificate, registration or any other authority Refused?',
            answers: [disclosures.applicationEverRefused],
            furtherComments: disclosures.applicationEverRefusedComment ? disclosures.applicationEverRefusedComment : ''
          },
          {
            question:
              'Have you held any licence, certificate, registration or any other authority which was cancelled for disciplinary reasons or which is suspended?',
            answers: [disclosures.heldSuspendedDocument],
            furtherComments: disclosures.heldSuspendedDocumentComment ? disclosures.heldSuspendedDocumentComment : ''
          },
          {
            question:
              'Have you been investigated (or are you currently being investigated) which may result in disciplinary action being taken against you?',
            answers: [disclosures.disciplinaryAgainstYou],
            furtherComments: disclosures.disciplinaryAgainstYouComment ? disclosures.disciplinaryAgainstYouComment : ''
          }
        ]
      },
      {
        questionGroupDescription: 'Prerequisites',
        questionAnswers: [
          {
            question: "Have you read the Fact Sheet 'Applying for a Tattooist Licence'?",
            answers: [tattooistDetails.factSheet],
            furtherComments: ''
          },
          {
            question:
              'Are you a controlled member of a declared organisation under the Crimes (Criminal Organisations Control) Act 2012?',
            answers: [tattooistDetails.act2012],
            furtherComments: ''
          },
          {
            question: 'Are you an Australian citizen or an Australian resident?',
            answers: [tattooistDetails.residentCitizen],
            furtherComments: ''
          },
          {
            question: 'Are you at least 18 years of age?',
            answers: [tattooistDetails.above18],
            furtherComments: ''
          },
          {
            question:
              'Do you consent to having your fingerprints and palm prints taken by a police officer in order to confirm your identity, and to being subject to a national criminal history record check?',
            answers: [tattooistDetails.fingerprints],
            furtherComments: ''
          }
        ]
      }
    ],
    attachments: [...JSON.parse(documents.filesQualification), ...JSON.parse(documents.filesTrade)]
  };
  return formattedJSON;
};

const getOwnershipName = (corp) => {
  if (corp.regoType === 'ABN' || corp.regoType === 'ACN') {
    return corp.businessName;
  } else if (corp.regoType === 'YINC') {
    return corp.YINCName;
  }
};

const getRegoNumber = (corp) => {
  if (corp.regoType === 'ABN') {
    return corp.abn;
  } else if (corp.regoType === 'ACN') {
    return corp.acn;
  } else if (corp.regoType === 'YINC') {
    return corp.YINCDetails;
  }
};

const formattedOperatorJsonTOSubmit = (
  application,
  applicantDetails,
  ownershipDetails,
  closeAssociatesDetails,
  premisesDetails,
  collectionOfLicence,
  disclosures,
  documents,
  tattooistDetails,
  twoFA
) => {
  const data = {};

  let individualList = [];
  let organisationList = [];
  let premiseList = [];

  // Close associate individuals
  if (closeAssociatesDetails && closeAssociatesDetails.individuals) {
    individualList = individualList.concat(
      closeAssociatesDetails.individuals.map((ind, index) => {
        return {
          roles: ['Close Associate'],
          id: 'closeassociate' + index,
          title: ind.title,
          gender: ind.gender,
          firstName: ind.firstName,
          middleName: ind.middleName,
          surname: ind.lastName,
          dateofbirth: moment(ind.monthOfBirth + '/' + ind.dayOfBirth + '/' + ind.yearOfBirth).format('DD/MM/YYYY'),
          placeOfBirth: ind.placeOfBirth,
          twoFaVerified: false,
          hasOtherNames: false,
          otherNames: null,
          identificationDetails: null,
          contactPart: ind.contactPart,
          addresses: [
            {
              addressType: 'Residential',
              enterManually: true,
              manualAddress: ind.addressResidential.manualAddress,
              lookupValue: ind.addressResidential.lookupValue,
              details: ind.addressResidential.details
            },
            {
              addressType: 'Postal',
              enterManually: true,
              manualAddress: ind.addressPostal.manualAddress,
              lookupValue: ind.addressPostal.lookupValue,
              details: ind.addressPostal.details
            }
          ]
        };
      })
    );
  }

  // close associate employees
  if (closeAssociatesDetails && closeAssociatesDetails.employees) {
    individualList = individualList.concat(
      closeAssociatesDetails.employees.map((ind, index) => {
        return {
          roles: ['Employee'],
          id: 'employee' + index,
          title: ind.title,
          gender: ind.gender,
          firstName: ind.firstName,
          middleName: ind.middleName,
          surname: ind.lastName,
          dateofbirth: moment(ind.monthOfBirth + '/' + ind.dayOfBirth + '/' + ind.yearOfBirth).format('DD/MM/YYYY'),
          placeOfBirth: ind.placeOfBirth,
          twoFaVerified: false,
          hasOtherNames: false,
          otherNames: null,
          identificationDetails: null,
          contactPart: ind.contactPart,
          addresses: [
            {
              addressType: 'Residential',
              enterManually: true,
              manualAddress: ind.addressResidential.manualAddress,
              lookupValue: ind.addressResidential.lookupValue,
              details: ind.addressResidential.details
            },
            {
              addressType: 'Postal',
              enterManually: true,
              manualAddress: ind.addressPostal.manualAddress,
              lookupValue: ind.addressPostal.lookupValue,
              details: ind.addressPostal.details
            }
          ]
        };
      })
    );
  }

  // Close associate corporations
  if (closeAssociatesDetails && closeAssociatesDetails.corporations) {
    organisationList = organisationList.concat(
      closeAssociatesDetails.corporations.map((c, index) => {
        return {
          roles: ['Close Associate'],
          id: 'organisation' + index,
          registrationType: c.regoType,
          registrationNumber: getRegoNumber(c),
          name: getOwnershipName(c),
          phoneNumber: c.phoneNo,
          emailAddress: c.email,
          webAddress: c.webAddress
        };
      })
    );
  }

  // Ownership corporation details
  if (
    ownershipDetails &&
    ownershipDetails.ownershipType === 'corporation' &&
    ownershipDetails.corporation &&
    ownershipDetails.corporation.length > 0
  ) {
    organisationList = organisationList.concat(
      ownershipDetails.corporation.map((c, index) => {
        return {
          roles: ['Business Owner'],
          id: 'organisation' + index,
          registrationType: c.regoType,
          registrationNumber: getRegoNumber(c),
          name: getOwnershipName(c),
          phoneNumber: c.phoneNo,
          emailAddress: c.email,
          webAddress: c.webAddress
        };
      })
    );
  }

  // Partner Details
  if (
    ownershipDetails &&
    ownershipDetails.ownershipType === 'partner' &&
    ownershipDetails.partner &&
    ownershipDetails.partner.length > 0
  ) {
    individualList = individualList.concat(
      ownershipDetails.partner.map((ind, index) => {
        return {
          roles: ['Business Owner'],
          id: 'employee' + index,
          title: ind.title,
          gender: ind.gender,
          firstName: ind.firstName,
          middleName: ind.middleName,
          surname: ind.lastName,
          dateofbirth: moment(ind.monthOfBirth + '/' + ind.dayOfBirth + '/' + ind.yearOfBirth).format('DD/MM/YYYY'),
          placeOfBirth: ind.placeOfBirth,
          twoFaVerified: false,
          hasOtherNames: false,
          otherNames: null,
          identificationDetails: null,
          contactPart: ind.contactPart,
          addresses: [
            {
              addressType: 'Residential',
              enterManually: true,
              manualAddress: ind.addressResidential.manualAddress,
              lookupValue: ind.addressResidential.lookupValue,
              details: ind.addressResidential.details
            },
            {
              addressType: 'Postal',
              enterManually: true,
              manualAddress: ind.addressPostal.manualAddress,
              lookupValue: ind.addressPostal.lookupValue,
              details: ind.addressPostal.details
            }
          ]
        };
      })
    );
  }

  // Trust Details
  if (
    ownershipDetails &&
    ownershipDetails.ownershipType === 'trust' &&
    ownershipDetails.trust &&
    ownershipDetails.trust.length > 0
  ) {
    organisationList = organisationList.concat(
      ownershipDetails.trust.map((c, index) => {
        return {
          roles: ['Business Owner'],
          id: 'organisation' + index,
          registrationType: c.regoType,
          registrationNumber: c.abn,
          name: c.trustName,
          phoneNumber: c.phoneNo,
          emailAddress: c.email,
          webAddress: c.webAddress
        };
      })
    );
  }

  // // Premise details
  if (premisesDetails) {
    premiseList.push({
      businessName: premisesDetails.businessName,
      id: 'premise1',
      roles: ['Primary Premises'],
      premiseAddresses: [premisesDetails.premiseAddress]
    });
  }

  let formattedJSON = {
    applicationId: application.applicationId,
    licenceType: 'Operator Licence',
    applicationNo: application.applicationNo,
    applicantType: 'individual',
    durationRequested: tattooistDetails.duration,
    ownershiptype: ownershipDetails.ownershipType,
    collectionServiceCentre: collectionOfLicence.centreLocation.value,
    individualApplicantDetails: {
      roles: ['Applicant'],
      id: 'applicant1',
      firstName: twoFA.data ? twoFA.data.firstName : '',
      middleName: '',
      surname: twoFA.data ? twoFA.data.lastName : '',
      dateofbirth: twoFA.data
        ? moment(twoFA.data.month + '/' + twoFA.data.day + '/' + twoFA.data.year).format('DD/MM/YYYY')
        : null,
      placeOfBirth: applicantDetails.placeOfBirth,
      twoFaVerified: twoFA.data ? true : false,
      hasOtherNames: applicantDetails.hasOtherNames == 'yes' ? true : false,
      otherNames: applicantDetails.otherNames,
      identificationDetails: applicantDetails.identificationDetails,
      contactPart: applicantDetails.contactPart,
      addresses: [
        {
          addressType: 'Residential',
          enterManually: true,
          manualAddress: applicantDetails.addressResidential.manualAddress,
          lookupValue: {},
          details: {}
        },
        {
          addressType: 'Postal',
          enterManually: true,
          manualAddress: applicantDetails.addressPostal.manualAddress,
          lookupValue: {},
          details: {}
        }
      ]
    },
    associatedIndividuals: individualList,
    associatedOrganisations: organisationList,
    premisesList: premiseList,
    questionList: [
      {
        questionGroupDescription: 'Disclosures',
        questionAnswers: [
          {
            question:
              'Have you had any application for any licence, certificate, registration or any other authority Refused?',
            answers: [disclosures.applicationEverRefused],
            furtherComments: disclosures.applicationEverRefusedComment ? disclosures.applicationEverRefusedComment : ''
          },
          {
            question:
              'If the business is owned/operated by a corporation/partnership/trust, has that entity had any application for a licence or other authority refused?',
            answers: [disclosures.partnerApplicationRefused],
            furtherComments: disclosures.partnerApplicationRefusedComment
              ? disclosures.partnerApplicationRefusedComment
              : ''
          },
          {
            question:
              'Have you held any licence, certificate, registration or any other authority which was cancelled for disciplinary reasons or which is suspended?',
            answers: [disclosures.heldSuspendedDocument],
            furtherComments: disclosures.heldSuspendedDocumentComment ? disclosures.heldSuspendedDocumentComment : ''
          },
          {
            question:
              'If the business is owned/operated by a corporation/partnership/trust, has that entity held a licence/authority which was cancelled or is suspended?',
            answers: [disclosures.partnerHeldSuspendedDocument],
            furtherComments: disclosures.partnerHeldSuspendedDocumentComment
              ? disclosures.partnerHeldSuspendedDocumentComment
              : ''
          },
          {
            question:
              'Are you currently being investigated which may result in disciplinary action being taken against you?',
            answers: [disclosures.disciplinaryAgainstYou],
            furtherComments: disclosures.disciplinaryAgainstYouComment ? disclosures.disciplinaryAgainstYouComment : ''
          },
          {
            question:
              'If the business is owned/operated by a corporation/partnership/trust is that entity being investigated which may result in disciplinary action?',
            answers: [disclosures.disciplinaryAgainstPartner],
            furtherComments: disclosures.disciplinaryAgainstPartnerComment
              ? disclosures.disciplinaryAgainstPartnerComment
              : ''
          },
          {
            question: 'Are you an undischarged bankrupt?',
            answers: [disclosures.undischargedBankrupt],
            furtherComments: disclosures.undischargedBankruptComment ? disclosures.undischargedBankruptComment : ''
          },
          {
            question:
              'If the business is owned/operated by a corporation/partnership/trust are any persons concerned with that entity an undischarged bankrupt?',
            answers: [disclosures.partnerUndischargedBankrupt],
            furtherComments: disclosures.partnerUndischargedBankruptComment
              ? disclosures.partnerUndischargedBankruptComment
              : ''
          },
          {
            question:
              'If the business is owned/operated by a corporation is that corporation subject to a winding up order or appointment of a controller or administrator?',
            answers: [disclosures.isCorporationSubjectToWindingUpOrder],
            furtherComments: disclosures.isCorporationSubjectToWindingUpOrderComment
              ? disclosures.isCorporationSubjectToWindingUpOrderComment
              : ''
          }
        ]
      },
      {
        questionGroupDescription: 'Prerequisites',
        questionAnswers: [
          {
            question: "Have you read the Fact Sheet 'Applying for a Tattooist Licence'?",
            answers: [tattooistDetails.factSheet],
            furtherComments: ''
          },
          {
            question:
              'Are you a controlled member of a declared organisation under the Crimes (Criminal Organisations Control) Act 2012?',
            answers: [tattooistDetails.act2012],
            furtherComments: ''
          },
          {
            question: 'Are you an Australian citizen or an Australian resident?',
            answers: [tattooistDetails.residentCitizen],
            furtherComments: ''
          },
          {
            question: 'Are you at least 18 years of age?',
            answers: [tattooistDetails.above18],
            furtherComments: ''
          },
          {
            question:
              'Do you consent to having your fingerprints and palm prints taken by a police officer in order to confirm your identity, and to being subject to a national criminal history record check?',
            answers: [tattooistDetails.fingerprints],
            furtherComments: ''
          }
        ]
      }
    ],
    attachments: [...JSON.parse(documents.filesQualification), ...JSON.parse(documents.filesTrade)]
  };
  return formattedJSON;
};

const formattedNewApplicationIndividualJsonToSubmit = (
  application,
  twoFA,
  individualApplicant,
  newApplicationDetail,
  individualLicenceInformation
) => {
  let associatedIndividuals = [];
  let associatedOrganisations = [];

  // Auditors
  newApplicationDetail.auditor.auditors.forEach(function (a) {
    if (a.auditorType === 'individual') {
      const newAuditor = {
        roleDetails: [
          {
            RoleType: 'Auditor',
            StartDate: a.startDate,
            EndDate: a.endDate
          }
        ],
        firstName: a.firstName,
        middleName: a.middleName,
        surname: a.lastName,
        contactPart: { emailAddress: a.contactPart.emailAddress, phoneNo: a.contactPart.dayTimeTelephoneNumber },
        addresses: getAddressDetail(a.address, null, false, null, null),
        regoNumber: a.registrationNumber,
        occupation: a.qualifications,
        id: 'applicant1'
      };
      associatedIndividuals.push(newAuditor);
    }

    if (a.auditorType === 'organisation') {
      const newAuditor = {
        roleDetails: [
          {
            RoleType: 'Auditor',
            StartDate: a.startDate,
            EndDate: a.endDate
          }
        ],
        roles: [],
        id: a.id,
        registrationType: a.regoType,
        registrationNumber: a.registrationNumber,
        name: a.businessName,
        emailAddress: a.contactPart.emailAddress,
        phoneNumber: a.contactPart.dayTimeTelephoneNumber,
        webAddress: a.contactPart.dayTimeTelephoneNumber,
        addresses: getAddressDetail(
          a.addressResidential,
          a.addressPostal,
          individualApplicant.sameAsResidential,
          null,
          null
        ),
        regoNumber: a.registrationNumber
      };
      associatedOrganisations.push(newAuditor);
    }

    if (a.hasOrgContact === 'Yes' && a.auditorType === 'organisation') {
      const organisationContactPerson = {
        roles: [],
        roleDetails: [
          {
            RoleType: 'Auditor',
            StartDate: a.organisationDetail.orgContactStartDate,
            EndDate: a.organisationDetail.orgContactEndDate
          }
        ],
        id: 'Auditor org contact',
        firstName: a.organisationDetail.orgContactFirstName,
        surname: a.organisationDetail.orgContactLastName,
        contactPart: {
          emailAddress: a.organisationDetail.orgContactEmailAddress,
          phoneNo: a.organisationDetail.orgContactNumber
        },
        addresses: getAddressDetail(
          a.organisationDetail.orgContactAddressResidential,
          a.organisationDetail.orgContactAddressPostal,
          a.organisationDetail.sameAsResidential,
          null,
          null
        ),
        relatedOrgName: a.businessName
      };

      associatedIndividuals.push(organisationContactPerson);
    }
  });

  // Individual traders
  newApplicationDetail.trader.traders.forEach(function (a) {
    const newTrader = {
      roleDetails: [
        {
          RoleType: 'Trader',
          StartDate: a.startDate,
          EndDate: a.endDate
        }
      ],
      firstName: a.firstName,
      middleName: a.middleName,
      surname: a.lastName,
      contactPart: { emailAddress: a.contactPart.emailAddress, phoneNo: a.contactPart.dayTimeTelephoneNumber },
      addresses: getAddressDetail(
        a.addressResidential,
        a.addressPostal,
        individualApplicant.sameAsResidential,
        null,
        null
      ),
      id: 'applicant1'
    };
    associatedIndividuals.push(newTrader);
  });

  // Organisation Traders
  // Organisation Traders
  newApplicationDetail.trader.organisationTraders.forEach(function (a) {
    const newTrader = {
      roleDetails: [
        {
          RoleType: 'Trader',
          StartDate: a.startDate,
          EndDate: a.endDate
        }
      ],
      roles: [],
      id: a.id,
      registrationType: a.regoType,
      registrationNumber: a.registrationNumber,
      name: a.businessName,
      emailAddress: a.organisationDetail.organisationEmailAddress,
      phoneNumber: a.organisationDetail.organisationDaytimeTelephoneNumber,
      addresses: a.isCreateOrganisation
        ? getAddressDetail(
            a.organisationDetail.addressResidential,
            a.organisationDetail.addressPostal,
            a.organisationDetail.sameAsResidential,
            null,
            null
          )
        : []
    };
    associatedOrganisations.push(newTrader);

    // Organisation Contact Person

    if (a.hasOrgContact === 'Yes') {
      const organisationContactPerson = {
        roles: [],
        roleDetails: [
          {
            RoleType: 'Contact Person',
            StartDate: a.startDate,
            EndDate: a.endDate
          }
        ],
        id: 'applicant1',
        firstName: a.firstName,
        surname: a.lastName,
        contactPart: {
          emailAddress: a.contactPart.emailAddress,
          phoneNo: a.contactPart.dayTimeTelephoneNumber
        },
        addresses: getAddressDetail(a.addressResidential, a.addressPostal, a.sameAsResidential, null, null),
        relatedOrgName: a.businessName
      };

      associatedIndividuals.push(organisationContactPerson);
    }
  });

  // Branches

  newApplicationDetail.branch.branches.forEach(function (a) {
    const newBranch = {
      // "roleDetails": [{
      //   "RoleType": "Branch",
      // }],
      roles: ['Sub-Branch'],
      id: a.id,
      registrationType: a.regoType,
      registrationNumber: a.registrationNumber,
      name: a.businessName
    };
    associatedOrganisations.push(newBranch);
  });

  let formattedJSON = {
    applicationId: application.applicationId,
    licenceType: 'Charitable Fundraising',
    applicationNo: application.applicationNo,
    applicantType: 'new-application',
    applicationType: 'Individual',
    durationRequested: newApplicationDetail.duration.detail,
    associatedIndividuals: associatedIndividuals,
    associatedOrganisations: associatedOrganisations,
    fundRaisingDetail: {
      charityObjects: newApplicationDetail.charitableObject.charityObject,
      natureDuration: newApplicationDetail.charitableObject.natureDuration,
      financialYearEnd: newApplicationDetail.charitableObject.financialYearEndDate,
      directorRemuneration: newApplicationDetail.charitableObject.directorRem,
      applicantOrgType: newApplicationDetail.charitableObject.applicantOrgType,
      parentOrganisation: newApplicationDetail.charitableObject.parentOrg,
      charityWebsiteUrl: newApplicationDetail.charitableObject.charityWebsiteUrl
    },
    individualApplicantDetails: {
      roles: ['Applicant'],
      id: individualLicenceInformation.licenceInfo.partyId,
      firstName: individualApplicant ? individualApplicant.firstName : '',
      middleName: individualApplicant ? individualApplicant.middleName : '',
      surname: individualApplicant ? individualApplicant.lastName : '',
      dateofbirth:
        individualApplicant && individualApplicant.dateOfBirth
          ? moment(individualApplicant.dateOfBirth).format('DD/MM/YYYY')
          : null,
      placeOfBirth: null, //applicantDetails.placeOfBirth,
      twoFaVerified: twoFA.data ? true : false,
      hasOtherNames: false,
      otherNames: null,
      identificationDetails: null,
      contactPart: {
        emailAddress: individualApplicant.contactPart.emailAddress,
        mobileNo: individualApplicant.contactPart.mobileNo,
        phoneNo: individualApplicant.contactPart.contactNumber
      },
      // "addresses": getAddressDetail(individualApplicant.addressResidential, individualApplicant.addressPostal, individualApplicant.sameAsResidential, null, "Individual"),
      addresses: getApplicantAddressDetail(
        individualApplicant.addressResidential,
        individualApplicant.addressPostal,
        individualLicenceInformation?.licenceInfo?.individual?.addresses
      )
      // "premisesList" : {
      //   "premiseAddresses":getAddressDetail(individualApplicant.addressResidential, individualApplicant.addressPostal, individualApplicant.sameAsResidential, twoFA.data.addressses, "Individual")
      // }
    },
    attachments: [...JSON.parse(newApplicationDetail.supportingDocument.documents)],
    questionList: [
      {
        questionGroupDescription: 'Auditor income appeals',
        questionAnswers: [
          {
            question: 'What is your income from appeals?',
            answers: [newApplicationDetail.auditor.auditors[0].incomeFromAppeals]
          }
        ]
      }
    ]
  };

  return formattedJSON;
};

const formattedNewApplicationOrganisationJsonToSubmit = (
  application,
  twoFA,
  organisationApplicant,
  newApplicationDetail
) => {
  let associatedIndividuals = [];
  let associatedOrganisations = [];

  // Auditors
  newApplicationDetail.auditor.auditors.forEach(function (a) {
    if (a.auditorType === 'individual') {
      const newAuditor = {
        roleDetails: [
          {
            RoleType: 'Auditor',
            StartDate: a.startDate,
            EndDate: a.endDate
          }
        ],
        id: 'applicant1',
        firstName: a.firstName,
        middleName: a.middleName,
        surname: a.lastName,
        contactPart: { emailAddress: a.contactPart.emailAddress, phoneNo: a.contactPart.dayTimeTelephoneNumber },
        addresses: getAddressDetail(a.address, null, false, null, null),
        regoNumber: a.registrationNumber,
        occupation: a.qualifications
      };
      associatedIndividuals.push(newAuditor);
    }

    if (a.auditorType === 'organisation') {
      const newAuditor = {
        roleDetails: [
          {
            RoleType: 'Auditor',
            StartDate: a.startDate,
            EndDate: a.endDate
          }
        ],
        roles: [],
        id: a.id,
        registrationType: a.regoType,
        registrationNumber: a.registrationNumber,
        name: a.businessName,
        emailAddress: a.organisationDetail?.organisationEmailAddress,
        phoneNumber: a.organisationDetail?.organisationDaytimeTelephoneNumber,
        // webAddress: a.contactPart.dayTimeTelephoneNumber,
        addresses: a.isCreateOrganisation
          ? getAddressDetail(a.addressResidential, a.addressPostal, organisationApplicant.sameAsResidential, null, null)
          : [],
        regoNumber: a.registrationNumber
      };
      associatedOrganisations.push(newAuditor);
    }

    if (a.hasOrgContact === 'Yes' && a.auditorType === 'organisation') {
      const organisationContactPerson = {
        roles: [],
        roleDetails: [
          {
            RoleType: 'Auditor',
            StartDate: a.organisationDetail.orgContactStartDate,
            EndDate: a.organisationDetail.orgContactEndDate
          }
        ],
        id: 'Auditor org contact',
        firstName: a.organisationDetail.orgContactFirstName,
        surname: a.organisationDetail.orgContactLastName,
        contactPart: {
          emailAddress: a.organisationDetail.orgContactEmailAddress,
          phoneNo: a.organisationDetail.orgContactNumber
        },
        addresses: getAddressDetail(
          a.organisationDetail.orgContactAddressResidential,
          a.organisationDetail.orgContactAddressPostal,
          a.organisationDetail.sameAsResidential,
          null,
          null
        ),
        relatedOrgName: a.businessName
      };

      associatedIndividuals.push(organisationContactPerson);
    }
  });
  // Individual traders
  newApplicationDetail.trader.traders.forEach(function (a) {
    const newTrader = {
      roleDetails: [
        {
          RoleType: 'Trader',
          StartDate: a.startDate,
          EndDate: a.endDate
        }
      ],
      id: 'applicant1',
      firstName: a.firstName,
      middleName: a.middleName,
      surname: a.lastName,
      contactPart: { emailAddress: a.contactPart.emailAddress, phoneNo: a.contactPart.dayTimeTelephoneNumber },
      addresses: getAddressDetail(
        a.addressResidential,
        a.addressPostal,
        organisationApplicant.sameAsResidential,
        null,
        null
      )
    };
    associatedIndividuals.push(newTrader);
  });

  // Organisation Traders
  newApplicationDetail.trader.organisationTraders.forEach(function (a) {
    const newTrader = {
      roleDetails: [
        {
          RoleType: 'Trader',
          StartDate: a.startDate,
          EndDate: a.endDate
        }
      ],
      roles: [],
      id: a.id,
      registrationType: a.regoType,
      registrationNumber: a.registrationNumber,
      name: a.businessName,
      emailAddress: a.organisationDetail.organisationEmailAddress,
      phoneNumber: a.organisationDetail.organisationDaytimeTelephoneNumber,
      addresses: a.isCreateOrganisation
        ? getAddressDetail(
            a.organisationDetail.addressResidential,
            a.organisationDetail.addressPostal,
            a.organisationDetail.sameAsResidential,
            null,
            null
          )
        : []
    };
    associatedOrganisations.push(newTrader);

    // Organisation Contact Person

    if (a.hasOrgContact === 'Yes') {
      const organisationContactPerson = {
        roles: [],
        roleDetails: [
          {
            RoleType: 'Contact Person',
            StartDate: a.startDate,
            EndDate: a.endDate
          }
        ],
        id: 'applicant1',
        firstName: a.firstName,
        surname: a.lastName,
        contactPart: {
          emailAddress: a.contactPart.emailAddress,
          phoneNo: a.contactPart.dayTimeTelephoneNumber
        },
        addresses: getAddressDetail(a.addressResidential, a.addressPostal, a.sameAsResidential, null, null),
        relatedOrgName: a.businessName
      };

      associatedIndividuals.push(organisationContactPerson);
    }

    // const organisationContactPerson = {
    //   roleDetails: [
    //     {
    //       RoleType: 'Contact Person',
    //       StartDate: a.startDate,
    //       EndDate: a.endDate
    //     }
    //   ],
    //   id: 'applicant1',
    //   firstName: a.firstName,
    //   middleName: a.middleName,
    //   surname: a.lastName,
    //   contactPart: { emailAddress: a.contactPart.emailAddress, phoneNo: a.contactPart.dayTimeTelephoneNumber },
    //   addresses: getAddressDetail(
    //     a.addressResidential,
    //     a.addressPostal,
    //     organisationApplicant.sameAsResidential,
    //     null,
    //     null
    //   )
    // };

    // associatedIndividuals.push(organisationContactPerson);
  });

  // Branches

  newApplicationDetail.branch.branches.forEach(function (a) {
    const newBranch = {
      // "roleDetails": [{
      //   "RoleType": "Branch",
      // }],
      roles: ['Sub-Branch'],
      id: a.id,
      registrationType: a.regoType,
      registrationNumber: a.registrationNumber,
      name: a.businessName,
      addresses: a.isCreateOrganisation
        ? getAddressDetail(
            a.organisationDetail.addressResidential,
            a.organisationDetail.addressPostal,
            a.organisationDetail.sameAsResidential,
            null,
            null
          )
        : [],
      emailAddress: a.isCreateOrganisation ? a.organisationDetail?.organisationEmailAddress : null,
      phoneNumber: a.isCreateOrganisation ? a.organisationDetail?.organisationDaytimeTelephoneNumber : null
    };
    associatedOrganisations.push(newBranch);

    if (a.hasOrgContact === 'Yes') {
      associatedIndividuals = associatedIndividuals.concat({
        roles: [],
        roleDetails: [
          {
            RoleType: 'Contact Person',
            StartDate: a.organisationDetail.orgContactStartDate,
            EndDate: a.organisationDetail.orgContactEndDate
          }
        ],
        firstName: a.organisationDetail.orgContactFirstName,
        surname: a.organisationDetail.orgContactLastName,
        contactPart: {
          emailAddress: a.organisationDetail.orgContactEmailAddress,
          phoneNo: a.organisationDetail.orgContactNumber
        },
        addresses: getAddressDetail(
          a.organisationDetail.orgContactAddressResidential,
          a.organisationDetail.orgContactAddressPostal
        ),
        relatedOrgName: a.businessName
      });
    }
  });

  // You Contact etails

  const applicantDetails = {
    roleDetails: [
      {
        RoleType: 'Contact Person',
        StartDate: organisationApplicant.startDate,
        EndDate: organisationApplicant.endDate
      }
    ],
    id: 'applicant1',
    firstName: organisationApplicant.firstName,
    middleName: organisationApplicant.middleName,
    surname: organisationApplicant.lastName,
    contactPart: {
      emailAddress: organisationApplicant.contactPart.emailAddress,
      phoneNo: organisationApplicant.contactPart.contactNmuber,
      mobileNo: organisationApplicant.contactPart.mobileNo
    }
    //"addresses": getAddressDetail(a.addressResidential, a.addressPostal, organisationApplicant.sameAsResidential, null, null),
  };

  // Other authorised contacts
  organisationApplicant.contacts.forEach(function (a) {
    let isPrimary = false;

    if (organisationApplicant.primaryContact) {
      isPrimary = `${a.firstName} ${a.lastName}` === organisationApplicant.primaryContact;
    }
    const newContactAddresses = getAddressDetail(
      a.addressResidential,
      a.addressPostal,
      a.sameAsResidential,
      null,
      null
    );
    const newContacts = {
      roleDetails: [
        {
          RoleType: 'Contact Person',
          StartDate: `${moment(new Date()).format('DD/MM/YYYY')}`,
          IsPrimary: isPrimary
        }
      ],
      id: 'applicantId',
      firstName: a.firstName,
      middleName: a.middleName,
      surname: a.lastName,
      contactPart: {
        emailAddress: a.contactPart.emailAddress,
        phoneNo: a.contactPart.dayTimeTelephoneNumber,
        mobileNo: a.contactPart.mobileNumber
      },
      addresses: newContactAddresses
    };
    associatedIndividuals.push(newContacts);
  });

  associatedIndividuals.push(applicantDetails);

  const adresses = getMultipleAddressDetail(
    organisationApplicant.officeAddress,
    organisationApplicant.otherAddresses,
    organisationApplicant.sameAsRegisteredBusiness
  );
  let formattedJSON = {
    applicationId: application.applicationId,
    licenceType: 'Charitable Fundraising',
    applicationNo: application.applicationNo,
    applicantType: 'new-application',
    applicationType: 'Organisation',
    durationRequested: newApplicationDetail.duration.detail,
    associatedIndividuals: associatedIndividuals,
    associatedOrganisations: associatedOrganisations,
    fundRaisingDetail: {
      charityObjects: newApplicationDetail.charitableObject.charityObject,
      natureDuration: newApplicationDetail.charitableObject.natureDuration,
      financialYearEnd: newApplicationDetail.charitableObject.financialYearEndDate,
      directorRemuneration: newApplicationDetail.charitableObject.directorRem,
      applicantOrgType: newApplicationDetail.charitableObject.applicantOrgType,
      parentOrganisation: newApplicationDetail.charitableObject.parentOrg,
      charityWebsiteUrl: newApplicationDetail.charitableObject.charityWebsiteUrl
    },
    organisationApplicantDetails: {
      roles: ['Applicant'],
      id: newApplicationDetail?.organisationLicence.licenceInfo?.orgRowId,
      registrationType: organisationApplicant.regoType,
      registrationNumber: organisationApplicant.registrationNumber,
      entityType: organisationApplicant.entityType,
      webAddress: organisationApplicant.webUrl,
      name: organisationApplicant.name,
      // "emailAddress": organisationApplicant.contactPart.emailAddress,
      // "phoneNumber": organisationApplicant.contactPart.mobileNo, phoneNo: organisationApplicant.contactPart.contactNmuber,
      addresses: adresses,
      orgStructure: organisationApplicant.entityType,
      registeredwithACNC: organisationApplicant.isAcnc === 'Yes' ? 'Y' : 'N'
    },
    attachments: [...JSON.parse(newApplicationDetail.supportingDocument.documents)],
    questionList: [
      {
        questionGroupDescription: 'Auditor income appeals',
        questionAnswers: [
          {
            question: 'What is your income from appeals?',
            answers: [newApplicationDetail.auditor.auditors[0].incomeFromAppeals]
          }
        ]
      }
    ],
    premisesList: [
      {
        businessName: organisationApplicant.name,
        id: 'premise1',
        roles: ['Primary Premises'],
        premiseAddresses: adresses
      }
    ]
  };

  return formattedJSON;
};

export {
  formatAddress,
  onlyNumbers,
  onlyCharacters,
  onlyPhoneCharacters,
  setDigitsAndFocusNext,
  formatMoney,
  formattedJsonTOSubmit,
  formattedOperatorJsonTOSubmit,
  objOfJsonArrayItem,
  format2FAAddress,
  getAddress,
  getFinalDuplicateAdddress,
  getFinalAdddress,
  formattedNewApplicationIndividualJsonToSubmit,
  formattedNewApplicationOrganisationJsonToSubmit,
  toCamelCase,
  getFormatAddressFromAddressLine
};
